export default el => {
    const video = el;

    const timeupdate = () => {
        if (video.currentTime < 0.001) {
            return;
        }
        video.removeEventListener('timeupdate', timeupdate);
        TweenLite.to(video, 0.5, { opacity: 1, ease: Sine.easeOut });
    };

    const init = () => {
        video.addEventListener('timeupdate', timeupdate);
    };

    const destroy = () => {
        video.removeEventListener('timeupdate', timeupdate);
    };

    return {
        init,
        destroy
    };
};



// WEBPACK FOOTER //
// ./src/js/components/VideoLoop.js